// extracted by mini-css-extract-plugin
module.exports =  {"footer-mobile":"_84ff5fbbc9--footer-mobile--R4Dba","footer-mobile--adaptive":"_84ff5fbbc9--footer-mobile--adaptive--fxAnF"};